module.exports = __webpack_public_path__ + "static/media/red-number-0.32a98e83.png";